export default {
  lines: {
    po: 50
  }
}



// WEBPACK FOOTER //
// ./src/utils/pageSizes.js